import { useState } from "react";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { AdminLoginDialog } from "./AdminLoginDialog";
import { InstallButton } from "./InstallButton";
import { Shield, LogOut, Tv, Zap, QrCode } from "lucide-react";

export function Header({ onTvMode }) {
  const { isAdmin, logout } = useAuth();
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 ap-glass border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <Zap className="w-5 h-5 text-slate-950" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-lg sm:text-xl uppercase tracking-tight text-white">
              American Padel
            </div>
            <div className="font-mono text-[10px] sm:text-xs text-emerald-400 tracking-[0.3em]">
              STAGIONE 2026
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <InstallButton />
          <a
            data-testid="print-qr-link"
            href="/print/qr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-md text-sm h-9 px-3 text-slate-300 hover:text-emerald-400 hover:bg-slate-800/60 transition-colors"
            title="Stampa i QR dei giocatori"
          >
            <QrCode className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline font-semibold uppercase text-xs tracking-wide">QR</span>
          </a>
          <Button
            data-testid="tv-mode-toggle-btn"
            onClick={onTvMode}
            variant="ghost"
            size="sm"
            className="text-slate-300 hover:text-emerald-400 hover:bg-slate-800/60"
          >
            <Tv className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline font-semibold uppercase text-xs tracking-wide">TV</span>
          </Button>

          {isAdmin ? (
            <div className="flex items-center gap-2">
              <span className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/15 border border-emerald-500/30 text-emerald-400 text-xs font-bold uppercase tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 ap-live-dot" />
                Admin
              </span>
              <Button
                data-testid="admin-logout-btn"
                onClick={logout}
                variant="ghost"
                size="sm"
                className="text-slate-400 hover:text-rose-400 hover:bg-slate-800/60"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          ) : (
            <Button
              data-testid="admin-login-button"
              onClick={() => setLoginOpen(true)}
              size="sm"
              className="bg-slate-800 hover:bg-slate-700 text-slate-100 border border-slate-700 font-semibold uppercase text-xs tracking-wide"
            >
              <Shield className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Admin</span>
            </Button>
          )}
        </div>
      </div>
      <AdminLoginDialog open={loginOpen} onOpenChange={setLoginOpen} />
    </header>
  );
}
